import url from "../../../utils/url";
import regionalTariffSteps from '../utils/regionalTariffSteps'

const TariffModel = () => ({
  operatorName: '',
  operatorObjectName: '',
  tariff: '',
  tariffSurcharge: '',
  v_waste: '',
  m_waste: ''
})

const TransportCostModel = () => ({
  index: '',
  val_i: '',
  val_i_1: ''
})

const GrossRevenueModel = () => ({
  operatorName: '',
  operatorObjectName: '',
  tariff: '',
  tariffSurcharge: '',
  v_waste_prev: '',
  m_waste_prev: '',
  v_waste_fact: '',
  m_waste_fact: ''
})

const TariffConsiderSentModel = () => ({
  operatorName: '',
  operatorObjectName: '',
  tariff: '',
  tariffSurcharge: '',
  v_waste_i_1: '',
  m_waste_i_1: '',
  v_waste_i: '',
  m_waste_i: '',
  v_waste_i_n1: '',
  m_waste_i_n1: '',
  v_waste_i_n2: '',
  m_waste_i_n2: '',
  v_waste_i_n3: '',
  m_waste_i_n3: '',
  v_waste_i_n4: '',
  m_waste_i_n4: ''
})

const TABLE_TYPE_MAP = {
  tariffs: {
    Model: TariffModel,
    ref: 'tariffs',
    dbGetter: 'tariffs',
    storeGetter: 'tariffs',
    dataUrl: 'tariffsDataUrl',
    errorKey: 'tariffs'
  },
  transportCosts: {
    Model: TransportCostModel,
    ref: 'transportCosts',
    dbGetter: 'transportCosts',
    storeGetter: 'transportCosts',
    dataUrl: 'transportCostsDataUrl',
    errorKey: 'transportCosts'
  },
  grossRevenue: {
    Model: GrossRevenueModel,
    ref: 'grossRevenue',
    dbGetter: 'grossRevenue',
    storeGetter: 'grossRevenue',
    dataUrl: 'grossRevenueDataUrl',
    errorKey: 'grossRevenue'
  },
  tariffsConsiderSent: {
    Model: TariffConsiderSentModel,
    ref: 'tariffsConsiderSent',
    dbGetter: 'tariffsConsiderSent',
    storeGetter: 'tariffsConsiderSent',
    dataUrl: 'tariffsConsiderSentDataUrl',
    errorKey: 'tariffsConsiderSent'
  }
}

export default {
  computed: {
    regionalTariffSteps () {
      return regionalTariffSteps
    }
  },
  methods: {
    onSuccessSaveCalculation (response, afterSaveResponse) {
      this.showOnSuccess('Запись сохранена')
      this.unFreezeFrom()
      this.onSaveForm()
      let prevRoute = url.getPrevRoute(this.$route)
      setTimeout(() => {
        this.$router.push({
          name: 'calculation.regionalTariffs.view',
          params: {
            id: this.fields.id
          },
          query: {
            prevRoute
          }
        })
      }, 0)
    },
    clearTable () {
      // put  to store
      for (let tblName in TABLE_TYPE_MAP) {
        let d = TABLE_TYPE_MAP[tblName]
        this.$store.commit('setEndpointData', {
          endpoint: this[d.dataUrl],
          data: {
            data: []
          }
        })
      }
    },
    updateDataInTables () {
      // put to store and update table
      for (let tblName in TABLE_TYPE_MAP) {
        let d = TABLE_TYPE_MAP[tblName]
        console.log('endpoint', this[d.dataUrl])
        this.$store.commit('setEndpointData', {
          endpoint: this[d.dataUrl],
          data: {
            data: (this.item[d.dbGetter] || [])
          }
        })
        console.log('data', this.item[d.dbGetter])
        if (this.refs && this.refs[d.ref]) {
          this.refs[d.ref].fetchData()
        }
      }
    },
    addNewRowToTable (tblName) {
      if (TABLE_TYPE_MAP[tblName]) {
        let d = TABLE_TYPE_MAP[tblName]
        this.$refs[d.ref].createRow(new d.Model())
      }
    },
    putTablesDataToFieldsForSend (fields) {
      for (let tblName in TABLE_TYPE_MAP) {
        let d = TABLE_TYPE_MAP[tblName]
        fields[d.dbGetter] = this[d.storeGetter]
      }
      return fields
    },
    validateDataInTables: async function (hasError = false, errors = {}) {
      for (let tblName in TABLE_TYPE_MAP) {
        let d = TABLE_TYPE_MAP[tblName]
        let data = this[d.storeGetter]
        this.tableErrors[d.errorKey] = null
        if (!data) {
          continue
        }
        for (let i = 0; i < data.length; i++) {
          if (data[i]._storeUUID) {
            if (!data[i]._isValid || !data[i]._considerSaved) {
              this.tableErrors[d.errorKey] = 'Корректно заполните и сохраните все поля в таблице'
              return Promise.reject(1)
            }
          }
        }
      }
      return Promise.resolve(1)
    }
  }
}
